module.exports = __webpack_public_path__ + "img/500.e846be10.jpg";